// GraphQL operations allowed to run WITHOUT an auth token — login, password
// reset, invite acceptance, and the 2FA / QR handshake. Single source of truth
// shared by every auth link so the allow-list cannot drift between clients
// (previously auth-link.js and auth-link-bo.js kept divergent copies).
//
// NOTE: authenticated operations (e.g. the My Account 2FA-change mutations
// sendTwoFactorOtp / confirmTwoFactorChange) must NOT be listed here.
export const PUBLIC_OPERATIONS = [
  "AuthenticateUser",
  "ChangePassword",
  "UpdatePassword",
  "ChangePasswordTokenValid",
  "InviteTokenInfo",
  "AcceptUserInvite",
  "userMContactMethods",
  "initiateTwoFactorActivation",
  "activateTwoFactorAndLogin",
  "validateOtpAndLogin",
  "resendOtp",
  "skipTwoFactorAndLogin",
  "authenticateWithQrToken",
  "initQrSession",
];

export function isPublicOperation(operationName) {
  return PUBLIC_OPERATIONS.includes(operationName);
}
